export const API_PATH =
  window.location.protocol + "//" + "staging.pmhsolution.com";

  export const API_PATH_GO ="https://api-navamin9.space-trax.com";

  export const API_PATH_TELEMED = "https://api-navamin9.space-trax.com";
  // "https://demo.space-trax.com";
  // "https://api-navamin9.space-trax.com";